export default __webpack_public_path__ + "static/media/Arrow-left-gray.02f49528.svg";